import React from "react";
import { ToastContainer } from "react-toastify";

// modules
import Products from "./modules/products";

// css
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/main.css";
import "./assets/css/responsive.css";


function App() {
  return (
    <div className="app">
      <Products />
      <ToastContainer position="bottom-right" />
    </div>
  );
}

export default App;
